(() => {
  // BTAのAvailability Searchページ以外では何もしない
  if (!window.location.pathname.startsWith('/apps/bookthatapp/search')) return;

  // Shopifyのコレクション名を変更した場合は、ここも変更する
  const DEFAULT_COLLECTION = '七五三レンタル';

  let defaultApplied = false;
  let rootObserver = null;

  function findCollectionSelect(root) {
    return [...root.querySelectorAll('select')].find((select) =>
      [...select.options].some(
        (option) => option.value === DEFAULT_COLLECTION
      )
    );
  }

  function applyControls() {
    const root = document.querySelector('#bta-search-root');
    if (!root) return false;

    const select = findCollectionSelect(root);

    if (select) {
      // 空欄の選択肢を削除
      select.querySelectorAll('option.empty').forEach((option) => {
        option.remove();
      });

      // 初回のみ「七五三レンタル」を自動選択
      if (!defaultApplied) {
        const defaultOption = [...select.options].find(
          (option) => option.value === DEFAULT_COLLECTION
        );

        if (defaultOption) {
          defaultApplied = true;

          select.value = DEFAULT_COLLECTION;
          select.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      }
    }

    // 「条件をクリア」を非表示
    [...root.querySelectorAll('button')].forEach((button) => {
      if (button.textContent.trim() === '条件をクリア') {
        button.style.setProperty('display', 'none', 'important');
      }
    });

    return true;
  }

  function startRootObserver() {
    const root = document.querySelector('#bta-search-root');

    if (!root || rootObserver) return;

    rootObserver = new MutationObserver(() => {
      applyControls();
    });

    rootObserver.observe(root, {
      childList: true,
      subtree: true
    });

    applyControls();
  }

  // BTAは後から検索UIを描画するため、表示されるまで待つ
  const pageObserver = new MutationObserver(() => {
    if (document.querySelector('#bta-search-root')) {
      startRootObserver();
      pageObserver.disconnect();
    }
  });

  if (document.querySelector('#bta-search-root')) {
    startRootObserver();
  } else {
    pageObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();